var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 60,
    viewBox: "0 0 89 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.09009,
    y: 0.580385,
    width: 86.4,
    height: 58.8392,
    rx: 6.38424,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.16077
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0913 40.6458H21.7868L17.8091 25.4811C17.6203 24.7835 17.2194 24.1668 16.6297 23.8762C15.1581 23.1457 13.5365 22.5644 11.7675 22.2712V21.6874H20.3126C21.492 21.6874 22.3765 22.5644 22.5239 23.583L24.5878 34.5218L29.8897 21.6874H35.0467L27.0913 40.6458ZM37.9951 40.6458H32.9855L37.1106 21.6874H42.1202L37.9951 40.6458ZM48.6015 26.9393C48.7489 25.9182 49.6334 25.3344 50.6654 25.3344C52.287 25.1878 54.0534 25.4809 55.5276 26.2089L56.4121 22.127C54.9379 21.5432 53.3163 21.25 51.8447 21.25C46.9825 21.25 43.4444 23.876 43.4444 27.5206C43.4444 30.2932 45.9505 31.749 47.7196 32.626C49.6334 33.5005 50.3705 34.0844 50.2231 34.9589C50.2231 36.2706 48.7489 36.8545 47.2773 36.8545C45.5083 36.8545 43.7393 36.4172 42.1202 35.6868L41.2357 39.7711C43.0048 40.499 44.9186 40.7922 46.6876 40.7922C52.1395 40.9363 55.5276 38.3128 55.5276 34.375C55.5276 29.4162 48.6015 29.1255 48.6015 26.9393ZM73.0601 40.6458L69.0823 21.6874H64.8098C63.9253 21.6874 63.0408 22.2712 62.7459 23.1457L55.3802 40.6458H60.5372L61.5666 37.8757H67.903L68.4927 40.6458H73.0601ZM65.5469 26.7926L67.0185 33.9377H62.8933L65.5469 26.7926Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.4dddf094f9628939fb32217706dee37f.svg";
export { ForwardRef as ReactComponent };